import { render, staticRenderFns } from "./PartnerRegister.vue?vue&type=template&id=66717150&scoped=true"
import script from "./PartnerRegister.vue?vue&type=script&lang=js"
export * from "./PartnerRegister.vue?vue&type=script&lang=js"
import style0 from "./PartnerRegister.vue?vue&type=style&index=0&id=66717150&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66717150",
  null
  
)

export default component.exports